<template>
  <v-layout row wrap>
    <v-flex xs12>
      <connection-manager ref="connectionManager" />
      <v-data-table
        ref="dataTable"
        :headers="headers"
        :items="operationHours"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.day }}</td>
          <td>{{ props.item.status }}</td>
          <td>{{ props.item.openTime }}</td>
          <td>{{ props.item.closeTime }}</td>
          <td>{{ props.item.comment }}</td>
          <td>
            <v-btn
              flat
              @click="
                deleteOperationHour(
                  props.item.id,
                  operationHours
                    .map(function(x) {
                      return x.id
                    })
                    .indexOf(props.item.id)
                )
              "
            >
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-form ref="form" v-model="valid" lazy-validation>
        <date-input
          v-if="!allDays"
          v-model="selectedDay"
          :disabled="connecting"
          placeholder="Select Date"
          :rules="[v => !!v || 'Date is required']"
        >
        </date-input>
        <v-checkbox v-model="allDays" label="All Days"></v-checkbox>
        <v-checkbox v-model="closed" label="Closed"></v-checkbox>
        <v-select
          v-model="openTime"
          :items="timesArray"
          label="Open Time"
          prepend-icon="access_time"
          :rules="[v => !!v || 'Open time is required']"
        >
        </v-select>
        <v-select
          v-model="closeTime"
          :items="timesArray"
          label="Close Time"
          :rules="[v => (v && validCloseTime) || 'Close time is not valid']"
          prepend-icon="access_time"
        >
        </v-select>
        <v-textarea
          name="note"
          rows="2"
          prepend-icon="note"
          v-model="comment"
          label="Write a comment (optional)"
          placeholder="Comment"
          :rules="[v => !!v || 'Comment is required']"
        >
        </v-textarea>
        <v-btn
          @click="submit"
          round
          color="primary"
          :disabled="!valid || connecting"
        >
          Submit
        </v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import Base from './Base.vue'
import DateInput from './DateInput'
import ConnectionManager from './ConnectionManager'
export default {
  components: {
    DateInput,
    ConnectionManager
  },
  name: 'Billing',
  extends: Base,
  data() {
    return {
      selectedDay: 'ALL_DAYS',
      openTime: null,
      closeTime: null,
      connecting: false,
      valid: true,
      allDays: true,
      closed: false,
      comment: '',
      loading: false,
      operationHours: [],
      rowsPerPageItems: [10],
      pagination: {
        rowsPerPage: 10
      },
      headers: [
        { text: 'id', sortable: false, value: 'id' },
        { text: 'Day', sortable: false, value: 'day' },
        { text: 'Status', sortable: false, value: 'status' },
        { text: 'Open Time', sortable: false, value: 'openTime' },
        { text: 'Close Time', sortable: false, value: 'closeTime' },
        { text: 'Comment', sortable: false, value: 'comment' }
      ],
      openTimeRules: [
        v => !!v || 'Open time is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ]
    }
  },
  computed: {
    timesArray() {
      const times = []
      const startTime = 8
      const endTime = 19
      for (var i = startTime; i <= endTime; i += 1) {
        times.push(i + ':' + '00')
      }
      return times
    },
    validCloseTime() {
      if (this.openTime && this.closeTime) {
        return (
          Number(this.closeTime.split(':')[0]) >
          Number(this.openTime.split(':')[0])
        )
      }
      return false
    }
  },
  watch: {
    allDays(newValue, oldValue) {
      if (this.allDays) {
        this.selectedDay = 'ALL_DAYS'
      }
    }
  },
  methods: {
    deleteOperationHour(id, index) {
      let that = this
      this.$refs.connectionManager.delete(
        'operationHours/' + id,
        {
          onSuccess(response) {
            //
            that.operationHours.splice(index)
          }
        },
        {}
      )
    },
    submit() {
      let that = this
      if (this.$refs.form.validate()) {
        this.$refs.connectionManager.post(
          'operationHours',
          {
            onSuccess(response) {
              that.$refs.form.reset()
              //
              that.getOperationsHours()
            }
          },
          {
            selectedDay: this.selectedDay,
            openTime: this.openTime.split(':')[0],
            closeTime: this.closeTime.split(':')[0],
            comment: this.comment,
            allDays: this.allDays ? 1 : 0,
            closed: this.closed ? 'CLOSED' : 'OPEN'
          }
        )
      }
    },
    getOperationsHours() {
      //
      let that = this
      this.$refs.connectionManager.get(
        'operationHours',
        {
          onSuccess(response) {
            //
            that.operationHours = response.data.data
          }
        },
        {}
      )
    }
  },
  mounted() {
    this.getOperationsHours()
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/OperationTimes.vue